import { ReactNode, useEffect, useState } from "react";
import React from "react";
import MessageModal from "./CustomMsgModal";

interface ErrorBoundaryProps {
  children: ReactNode;
}

const getErrorMessage = (error: any): string => {
  if ('response' in error && error.response?.data?.error) {
    return error.response.data.error;
  }
  return error.message;
};

const ErrorBoundary: React.FC<ErrorBoundaryProps> = ({ children }) => {
  const [error, setError] = useState<any | null>(null);

  useEffect(() => {
    const errorHandler = (ev: ErrorEvent) => {
      setError(ev.error);
    };

    window.addEventListener('error', errorHandler);

    return () => {
      window.removeEventListener('error', errorHandler);
    };
  }, []);

  useEffect(() => {
    const unhandledRejectionHandler = (ev: PromiseRejectionEvent) => {
      setError(ev.reason);
    };

    window.addEventListener('unhandledrejection', unhandledRejectionHandler);

    return () => {
      window.removeEventListener('unhandledrejection', unhandledRejectionHandler);
    };
  }, []);

  if (error) {
    const errorMessage = getErrorMessage(error);
    return <MessageModal
      title="Uh-Oh!"
      isError={true}
      isOpen={true}
      message={errorMessage}
      onConfirm={() => window.location.reload()} />;
  }

  return <>{children}</>;
};

export default ErrorBoundary;